import { useNavigate } from "react-router-dom";
import { getTextWorkCity, getTextWorkTime, formatDate } from "./common/BaseUtil"
import '../App.css'

export function JobTableRow(props) {
    let navigate = useNavigate();
    function onClick() {
        let objectId = props.object.id.toString()
        let url = "/job?id=" + objectId + "&returnTo=/job_list";
        navigate(url);
    }

    return (
        <tr key={props.index}>
            <td class="priority-1" onClick={onClick}>{props.object.objTitle}</td>
            <td class="priority-2" className="responsive-table-row">{getTextWorkCity(props.cityList, props.object.workCity)}</td>
            {/* <td class="priority-3" className="responsive-table-row">{getTextWorkTime(props.object.workTime)}</td> */}
            <td class="priority-4" className="responsive-table-row-date">{formatDate(props.object.updateAt)}</td>
        </tr>
    );
}